import { render, staticRenderFns } from "./ElemDate.vue?vue&type=template&id=04af45f6&"
import script from "./ElemDate.vue?vue&type=script&lang=js&"
export * from "./ElemDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports